export default __webpack_public_path__ + "static/media/icons8-github.7a0dc838.svg";